import { OrganizerPortalEvent } from '@radevents/shared';

/**
 * Die Schwelle, ab der eine Favoritenzahl als Vorgeschmack taugt.
 *
 * Unter vier Vormerkungen ist die Zahl kein Argument, sondern eines gegen uns: „2 Leute haben
 * dein Event gemerkt" liest sich wie eine Absage an die ganze Plattform. Dann sagt der Text
 * lieber, was passieren wird, statt was bisher passiert ist.
 */
export const TEASER_MIN_FAVORITES = 4;

/**
 * Das Event mit den meisten Vormerkungen, sofern es die Schwelle reisst.
 *
 * Statistiken gehoeren zu Premium, auch die Favoriten (01.09.2026). Genau **eine** Zahl darf
 * trotzdem heraus: die staerkste, als Vorgeschmack. Sie ist ohnehin oeffentlich (sie steht in
 * jeder Event-Antwort), und ohne sie waere jedes Verkaufsversprechen eine Behauptung.
 *
 * Bewusst ein einzelnes Event statt der Summe ueber alle: die Summe ist bereits eine Auswertung,
 * und die ist das Produkt.
 */
export const favoriteTeaser = (
  events: OrganizerPortalEvent[],
): { title: string; favorites: number } | null => {
  const best = [...events]
    .sort((a, b) => (b.event.favoriteCount ?? 0) - (a.event.favoriteCount ?? 0))[0];
  const favorites = best?.event.favoriteCount ?? 0;
  return favorites >= TEASER_MIN_FAVORITES ? { title: best.event.title, favorites } : null;
};
